import {trans} from "@utils"
import {WhatsNewIcon, LightIcon, ReleaseNotesIcon} from "../../icons"

export const knowledgeBase = {
  productUpdate: {
    title: 'layout.navbar.kbProductUpdate',
    link: "/kb/articles/product-update",
    icon: WhatsNewIcon
  },
  releaseNotes: {
    title: 'layout.navbar.kbReleaseNotes',
    link: "/kb/articles/release-notes",
    icon: ReleaseNotesIcon
  },
  knowledgeBase: {
    title: 'layout.navbar.help',
    link: "/kb",
    icon: LightIcon
  },
  tutorials: {
    title: 'layout.navbar.tutorials',
    link: "https://gumlet.tv/playlist/6749cc2fdad6bb7514bc8fb0",
    icon: LightIcon
  }
}

export const knowledgeBaseArticles = {
  checklist_how_to_import_checklist: {
    link: "/kb/articles/how-to-import-a-checklist-26-3-2024-1"
  },
  checklist_question_types: {
    link: "/kb/articles/supported-question-types"
  }
}
